import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Header from './Header';
import Login from './Login';
import Signup from './Signup';
import ConfirmSignup from './ConfirmSignup';
import ConfirmInvite from "./ConfirmInvite/ConfirmInvite";
import Consent from './Consent';
import ForgotPassword from './ForgotPassword';
import Authorize from './Authorize/Authorize';
import ResetPassword from './ResetPassword';
import PrivacyPolicy from './PrivacyPolicy';
import Error from './Error';
import Footer from './Footer';

const App = () => (
  <div>
    <div className="wrapper">
      <Header />
      <Switch>
        <Redirect exact from="/" to="/session/login" />
        <Route path="/session/login" component={Login} />
        <Route exact path="/session/signup" component={Signup} />
        <Route path="/session/signup/:token" component={ConfirmSignup} />
        <Route path="/session/invite/:requestId" component={ConfirmInvite} />
        <Route path="/session/consent" component={Consent} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/api/oauth/authorize" component={Authorize} />
        <Route path="/reset-password/:token" component={ResetPassword} />
        <Route path="/user-notice" component={PrivacyPolicy} />
        <Route path="/*" component={Error} />
      </Switch>
      <Footer />
    </div>
  </div>
);

export default App;
